//base on the next doc - https://docs.google.com/spreadsheets/d/1jHmqVAuJA8O5I9c-Vlfv-WPO0ABeezmrCj5S5XTksGU/edit#gid=349252300

export enum REPORT_PARAM_KEYS {
  AVG_FAST_6AM = 'AVG_FAST_6AM',
  AVG_DAILY = 'AVG_DAILY',
  GL_VARIABILITY_DAY = 'GL_VARIABILITY_DAY',
  TIME_IN_RANGE = 'TIME_IN_RANGE',
  NIGHT_hypoglycemia = 'NIGHT_hypoglycemia',
  GL_VARIABILITY_NIGHT = 'GL_VARIABILITY_NIGHT',
}

export enum REPORT_PARAM_NAMES {
  //The average value of the glucose level measured at 6 am (user time zone) (permissible deviation + -15 minutes) for a certain period of time.
  AVG_FAST_6AM = 'Fasting glucose',
  //"The average value of the average values of glucose levels for a certain period of time. Formula's explanation: AG - average glucose levels. "
  AVG_DAILY = 'Average daily glucose',
  //It is average standard deviation from average glucose levels, measured for a certain period of time (example 7 or 14 days)
  GL_VARIABILITY_DAY = 'Glucose variability',
  //It is average time in range for a certain period of time.
  TIME_IN_RANGE = 'Time in range',
  //"The total amount of episodes when user had glucose level lower than 65 mg\dl during the "" Night Time"". Night Time is considered as time from 22.00 to 8.00 user's time zone.  "
  NIGHT_hypoglycemia = 'Nocturnal hypoglycemia',
  //"It is average standard deviation from average glucose levels, measured for a certain period of time (example 7 or 14 days). But it should be measured during ""Night Time"". ""Night Time""  is considered as time from 22.00 to 8.00 user's time zone.  "
  GL_VARIABILITY_NIGHT = 'Glucose variability at night',
}
